import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import ButtonWrapper from '.././Button/index'
import WarningIconOrginal from '.././icons/WarningIcon'
import { PopUpContent } from './style'
/* --------------------------------------------- */
// WarningPopup component used to show warning popup.
const WarningPopup = ({ WarningClickHandle: ButtonOnClick }) => {
  const { popupTheme: theme } = useSelector(store => store.themeConfigReducers)
  const { supportConfig } = useSelector(store => store.support)
  /* ------------------------------------------------------------------------------------------------ */
  if (!supportConfig.errorConfiguration) supportConfig.errorConfiguration = []
  /* ------------------------------------------------------------------------------------------------ */
  let Errorconfig = supportConfig.errorConfiguration.filter((config) => {
    return config.type === 'PurchaseRequired'
  })[0]

  const {
    title: ErrorTitle,
    description: ErrorDescription,
  } = Errorconfig
  /* --------------------------------------------- */
  return (
    <div className='confirm-popup-wrapper purchase---pop-up'>
      <PopUpContent {...{ theme }} className='confirm-popup__content'>
        <WarningIconOrginal color='rgba(182,28,28,1)' style={{ width: 50, height: 50, marginBottom: 16 }} />
        <div className='confirm-popup-header'>
          <h2>{ErrorTitle}</h2>
        </div>
        <p>{ErrorDescription}</p>
        <ButtonWrapper
          {...{
            theme: theme && theme.compositeStyle && theme.compositeStyle.primaryButton,
            text: 'OK',
            onClick: ButtonOnClick
          }}
        />
      </PopUpContent>
    </div>
  )
}


WarningPopup.propTypes = {
  component: PropTypes.func,
  CloseHandler: PropTypes.func,
  title: PropTypes.string
}
/* --------------------------------------------- */

WarningPopup.defaultProps = {
  component: () => { },
  CloseHandler: () => { },
  title: ''
}

export default WarningPopup
